import React from 'react';

import { UserRole } from '@shared/types/user_role';

import { Roles } from '@admin/components/helpers/roles';

interface CustomerNameFieldProps {
  name: string;
  required: boolean;
  onChange: (value: string) => void;
}

/**
 * Component for rendering the customer name input with role-based access.
 *
 * @param props - The component props.
 * @returns The CustomerNameField component.
 */
export const CustomerNameField: React.FC<CustomerNameFieldProps> = ({ name, required, onChange }) => (
  <table className="table">
    <tbody>
      <tr>
        <td>
          <Roles hide={[UserRole.L1Agent]}>
            <input
              className="form-control"
              value={name}
              onChange={(e) => onChange(e.target.value)}
              required={required}
              placeholder="Name"
              type="text"
              aria-label="Customer name"
            />
          </Roles>
          <Roles show={[UserRole.L1Agent]}>
            <input
              className="form-control"
              value={name}
              placeholder="Name"
              type="text"
              disabled
              aria-label="Customer name"
            />
          </Roles>
        </td>
      </tr>
    </tbody>
  </table>
);
